import { isNullOrUndefined } from 'util';
import { ConvertToJSONService } from './convert-to-json.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { ConfigService } from '../config.service';
const headers = {
  headers: new HttpHeaders({ 'content-type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  ServerUrl = this.serverConfig.ServerUrl;
  ServerUrl2 = this.serverConfig.ServerUrl2;
  ServerUrl3 = this.serverConfig.ServerUrl3;
  ServerUrl6 = this.serverConfig.ServerUrl6;
  ServerUrl9 = this.serverConfig.ServerUrl9;
  ServerUrl5 = this.serverConfig.ServerUrl5;
  ServerUrlreport = this.serverConfig.ServerUrl4;
  ServerUrlThirdParty = this.serverConfig.ServerUrlThirdParty;
  IsWrapper = environment.IsWrapperAPI;
  CompanyName = environment.CompayName;
  // Don't remove this lines from here
  RMContact: string = '';
  RMName: string = '';
  //
  constructor(
    private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private ConvertToJSON: ConvertToJSONService,
    private serverConfig :ConfigService
  ) {}

  GetAccountInfo(id: string, UserType: string): Observable<any> {
    let DataUrl = '';
    let QueryString = '';

    id = this.EncrdecrService.setEncr(id);
    if (UserType === '2') {
      DataUrl = `${this.ServerUrl}/api/SignUp/GetAccountInfo`;
      QueryString = `SubBrokerId=${id}&ClientBasicInfoId=&UserType=2`;
    } else if (UserType === '1') {
      DataUrl = `${this.ServerUrl}/api/SignUp/GetAccountInfo`;
      QueryString = `SubBrokerId=${id}&ClientBasicInfoId=&UserType=1`;
    } else {
      DataUrl = `${this.ServerUrl9}/api/SignUp/GetAccountInfo`;
      let G_SubBrokerId = '';
      if (
        sessionStorage.getItem('ihjt45h45=sb') != '' ||
        sessionStorage.getItem('ihjt45h45=sb') != null
      ) {
        G_SubBrokerId = this.EncrdecrService.setEncr(
          sessionStorage.getItem('ihjt45h45=sb')
        ); //added by adarsh  03052023
      } //added by adarsh  03052023
      if (isNullOrUndefined(G_SubBrokerId)) {
        G_SubBrokerId = sessionStorage.getItem('Hldq31TLYwRbLJ8');
      }
      QueryString = `SubBrokerId=${G_SubBrokerId}&ClientBasicInfoId=${id}&UserType=3`;
    }

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    console.log('DataURl :' + DataUrl);
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log('Body ->  ' + JSON.stringify(body));
    console.log(
      'Token -> ' + token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    return this.http.post<any>(DataUrl, body, tokenOption).pipe();
  }

  GetEUINInfo(id: string): Observable<any> {
    let DataUrl = '';
    let QueryString = '';
    id = this.EncrdecrService.setEncr(id);
    DataUrl = `${this.ServerUrl}/api/SignUp/GetEUINInfo`;
    QueryString = `SubBrokerId=${id}`;

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    // console.log("DataURl :"+DataUrl) ;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(DataUrl, body, tokenOption).pipe();
  }

  GetClientInfo(ClientBasicInfoId): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let UserType = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + '@' + UserId + '|' + UserType + '|' + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/ClientOnBoardingBSE/ClientProfileDetails`;
    const QueryString = `ClientBasicInfoId=${this.EncrdecrService.setEncr(ClientBasicInfoId)}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log(DataUrl);
    console.log(body);
    return this.http.post<any>(DataUrl, body, tokenOption).pipe();
  }

  PostAccountInfo(formData): Observable<any> {
    debugger;
    let DataUrl = `${this.ServerUrl}/api/SignUp/SignUp`;
    return this.http.post<any>(DataUrl, formData, headers);
  }

  PostRTAMailBack(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/SignUp/RTAInfo`;
    return this.http.post<any>(DataUrl, formData, headers);
  }

  PostBSEstarInfo(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl2}/api/GetPasswordChange/ChangeBsePass`;
    return this.http.post<any>(DataUrl, formData, headers);
  }

  //added by adarsh 07042025
  PostBSEstarInfos(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/SignUp/BSECredentials`;
    return this.http.post<any>(DataUrl, formData, headers);
  }

  PostLogo(
    selectedFile: File,
    ARNNO,
    Domain_Name,
    PrimaryColor?,
    SecondaryColor?
  ): Observable<any> {
    debugger;
    const formData: FormData = new FormData();
    formData.append('Image', selectedFile, selectedFile.name);
    formData.append('PrimaryColor', PrimaryColor);
    formData.append('SecondaryColor', SecondaryColor);
    let DataUrl = `${this.ServerUrl}/api/SignUp/CompanyLogo?SubBrokerId=${ARNNO}&Domain_Name=${Domain_Name}`;
    return this.http.post<any>(DataUrl, formData);
  }
  PostColors(
    ARNNO,
    PrimaryColor,
    SecondaryColor,
    Flag_Type?,
    PlayStoreLink?
  ): Observable<any> {
    debugger;
    const formData: FormData = new FormData();
    formData.append('PrimaryColor', PrimaryColor);
    formData.append('SecondaryColor', SecondaryColor);
    formData.append('Flag_Type', Flag_Type);
    formData.append('PlayStoreLink', PlayStoreLink);
    let DataUrl = `${this.ServerUrl}/api/SignUp/CompanyColors?SubBrokerId=${ARNNO}`;
    return this.http.post<any>(DataUrl, formData);
  }

  PostAboutBanner(selectedFile: File, ARNNO, fname): Observable<any> {
    debugger;
    const formData: FormData = new FormData();
    formData.append('Image', selectedFile, selectedFile.name);
    let DataUrl = `${this.ServerUrl}/api/SignUp/AboutBanner?SubBrokerId=${ARNNO}&filename=${fname}`;
    return this.http.post<any>(DataUrl, formData);
  }

  //added by adarsh 31072024
  PostAMFIDetail(formData): Observable<any> {
    //comment before publish
    let DataUrl = `${this.ServerUrl}/api/SignUp/SaveAMFIDetails`;
    return this.http.post<any>(DataUrl, formData, headers);
  }

  PostEmailSettings(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/SignUp/EmailSettings`;
    return this.http.post<any>(DataUrl, formData, headers);
  }

  PostBasicDetails(formData): Observable<any> {
    let DataUrl = '';
    if (this.IsWrapper) {
      DataUrl = `${this.ServerUrl2}api/ClientOnBoardingBSE/Details`;
    } else {
      DataUrl = `${this.ServerUrl2}/api/ClientOnBoarding/Details`;
    }
    //console.log(DataUrl)
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    console.log('Fatca Save url ' + DataUrl);
    console.log('Fatca Save body ' + formData);
    console.log(
      'Fatca Save token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }
  PostPreBasicDetails(formData): Observable<any> {
    let DataUrl = '';
    if (this.IsWrapper) {
      DataUrl = `${this.ServerUrl2}api/CheckDetails/Details`;
    } else {
      DataUrl = `${this.ServerUrl2}/api/ClientOnBoarding/Details`;
    }
    //console.log(DataUrl)
    // let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    // let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    // let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    // let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    // const TOKEN = btoa(token +"@"+UserId+"|"+User_Type+"|"+IpAddress);
    //  const tokenOption = { headers:
    //   new HttpHeaders(
    //     {'Content-Type': 'application/json',
    //     'Authorization': `Basic ${TOKEN}`,
    //   })
    // }
    return this.http.post<any>(DataUrl, formData, headers);
  }
  PostDocuments(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        //'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/ClientOnBoardingBSE/UploadDocument`;
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }
  GetStateList(): Observable<any> {
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=State`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');

    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    console.log('GetStateList URL ' + DataUrl);
    console.log(
      'GetStateList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  GetRelationList(): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=RELATION_LIST`;
    console.log('GetRelationList URL ' + DataUrl);
    console.log(
      'GetRelationList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  GetBankList(): Observable<any> {
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingListDetails?TRANS_TYPE=Bank_list&REFF_ID2=BankCode`;

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    console.log('GetBankList URL ' + DataUrl);
    console.log(
      'GetBankList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl).pipe();
  }
  GetBankListBSE(): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=BankList`;
    console.log('GetBankListBSE URL ' + DataUrl);
    console.log(
      'GetBankListBSE URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }
  GetAccountTypeList(): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=AccountType`;
    console.log('GetAccountTypeList URL ' + DataUrl);
    console.log(
      'GetAccountTypeList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  GetIdentificationTypeList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=IdentificationType`;
    console.log('GetIdentificationTypeList URL ' + DataUrl);
    console.log(
      'GetIdentificationTypeList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  GetOccupationTypeList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=OccupationType`;
    console.log('GetOccupationTypeList URL ' + DataUrl);
    console.log(
      'GetOccupationTypeList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  GetAnnualIncomeList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=AnnualIncome`;
    console.log('GetAnnualIncomeList URL ' + DataUrl);
    console.log(
      'GetAnnualIncomeList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  GetGenerateUCC(ClientBasicInfoId) {
    ////////

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/UCCCreation/Details`;
    const QueryString = `FisrtHolderId=${ClientBasicInfoId}&Flag=SI&CompanyName=${this.CompanyName}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    //console.log(DataUrl)
    return this.http.post<any>(DataUrl, body, tokenOption).pipe();
  }

  PostAOFForm(formData): Observable<any> {
    ////////
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );

    const tokenOption = {
      headers: new HttpHeaders({
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/UCCCreation/AOFUpload`;
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }

  GetDownloadAOF(UCCCode) {
    let DataUrl = `${this.ServerUrl2}/api/UCCCreation/GenerateAOF?UCCCode=${UCCCode}`;
    //console.log(DataUrl)
    return this.http.get<any>(DataUrl).pipe();
  }
  GetDownloadNACH(UCCCode, NachMandateId) {
    let DataUrl = `${this.ServerUrl3}/api/NachMandate/DownloadNach?UCCCode=${UCCCode}&MandateId=${NachMandateId}&TRANS_TYPE=Bank_inFormation`;
    //console.log(DataUrl)
    return this.http.get<any>(DataUrl).pipe();
  }
  postFDDetails(data) {
    const url = `${this.ServerUrl6}/api/FD/UploadDocument`;
    const header = this.GetTokenNonJSON();
    return this.http.post<any>(url, data, header);
  }
  getFDDetails(ClientBasicInfoId) {
    const url = `${this.ServerUrl6}/api/FD/getFDDetails?ClientBasicInfoId=${ClientBasicInfoId}`;
    console.log('FD URL ' + url);
    const header = this.GetToken();
    return this.http.get<any>(url, header);
  }
  enableClientFD(ClientBasicInfoId) {
    const url = `${this.ServerUrl2}/api/FD/EnableFd`;
    const Data = { ClientbasicinfoID: ClientBasicInfoId };
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    return this.http.post<any>(url, Data, tokenOption);
  }
  VerifyPanEmailMobile(formData): Observable<any> {
    let DataUrl = '';
    if (this.IsWrapper) {
      DataUrl = `${this.ServerUrl2}api/CheckDetails/Details`;
    } else {
      DataUrl = `${this.ServerUrl2}api/CheckDetails/Details`;
    }

    //console.log(DataUrl)
    return this.http.post<any>(DataUrl, formData, headers);
  }
  // SendOTP(formData): Observable<any> {
  //   let DataUrl = `${this.ServerUrl2}/api/OTP_Birla/Details`;
  //   //console.log(DataUrl)
  //   return this.http.post<any>(DataUrl, formData, headers);
  // }
  SendOTP(formData): Observable<any> {
    let DataUrl = '';
    if (environment.CompayName == 'IFA') {
      DataUrl = `${this.ServerUrl5}/api/SendLoginDetails/SendOTP`;
    } else {
      DataUrl = `${this.ServerUrlThirdParty}/api/SMSService/SendOTP`;
    }
    //console.log(DataUrl)

    const req = {
      data: this.EncrdecrService.setEncr(formData)
    };
    return this.http.post<any>(DataUrl, req, headers);
  }
  CheckKYC(PANNO, MobileNo) {
    const header = this.GetToken();
    //let DataUrl = `${this.ServerUrlThirdParty}/api/KycCheck/KycCheck?PANNo=${PANNO}&MobileNo=${MobileNo}`;
    let DataUrl = `${this.ServerUrlThirdParty}/api/KYCCheck/CVLKRAKYC?PANNo=${PANNO}&MobileNo=${MobileNo}`;
    console.log(DataUrl);
    return this.http.get<any>(DataUrl, header);
  }
  GetAddressByPin(PinCode) {
    let DataUrl = `${this.ServerUrl2}/api/FillBank_details/GetDetail?Flag=&Code=${PinCode}`;
    const json = this.ConvertToJSON.QueryStringToJSON(DataUrl.split('?')[1]);

    return this.http.post<any>(DataUrl.split('?')[0], json, headers).pipe();
  }
  GetBankByIFSC(IFSCCode) {
    let DataUrl = `${this.ServerUrl2}/api/FillBank_details/GetDetail?Flag=IFSC&Code=${IFSCCode}`;
    const json = this.ConvertToJSON.QueryStringToJSON(DataUrl.split('?')[1]);

    return this.http.post<any>(DataUrl.split('?')[0], json, headers).pipe();
  }
  GetClientInfobypanno(PANNO, UserType, SB_ID) {
    let DataUrl = `${this.ServerUrlreport}api/ForgotPassword/ReportDetails`;
    let QueryString: any;
    if (environment.IsOptimoney) {
      QueryString = `PANNo=${PANNO}&TRANS_TYPE=CLIENTDETAILS_BYPAN&USER_TYPE=${UserType}`;
    } else {
      QueryString = `PANNo=${PANNO}&TRANS_TYPE=CLIENTDETAILS_BYPAN&USER_TYPE=${UserType}&SB_ID=${SB_ID}`;
    }
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    console.log(DataUrl);
    console.log(JSON.stringify(body));

    return this.http.post<any>(DataUrl, body, headers);
  }
  GetToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let UserType = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + '@' + UserId + '|' + UserType + '|' + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    return tokenOption;
  }
  KycCheckCVL(PANNO, MobileNo, DOB) {
    const header = this.GetToken();
    let DataUrl = `${this.ServerUrlThirdParty}/api/KYCCheck/KycCheckCVL?PANNo=${PANNO}&MobileNo=${MobileNo}&DOB=${DOB}`;
    const body = this.ConvertToJSON.QueryStringToJSON(DataUrl.split('?')[1]);
    return this.http.get<any>(DataUrl, header);
  }
  LoadKYC(formData) {
    const header = this.GetToken();
    let DataUrl = `${this.ServerUrlThirdParty}/api/KYCCheck/LoadKYCKotak`;
    return this.http.post<any>(DataUrl, formData, header);
  }
  CheckExistingPAN(formData): Observable<any> {
    let DataUrl = '';
    const header = this.GetToken();
    if (this.IsWrapper) {
      DataUrl = `${this.ServerUrl2}/api/ClientOnBoardingBSE/Details`;
    } else {
      DataUrl = `${this.ServerUrl2}/api/ClientOnBoarding/Details`;
    }
    //console.log(DataUrl)
    return this.http.post<any>(DataUrl, formData, header);
  }
  GetTokenNonJSON() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        Authorization: `Basic ${TOKEN}`
      })
    };
    return tokenOption;
  }
  SendCommonOTP(body): Observable<any> {
    const url = `${this.ServerUrl}api/CommonOTP/SendOTPSMS`;
    //const token = this.GetToken();
    console.log(url);
    return this.http.post<any>(url, body, headers);
  }
  PostNSEInfo(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/SignUp/NSECredentials`;
    return this.http.post<any>(DataUrl, formData, headers);
  }
  sendMandatectivationlink(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/ClientMandate/SendMandateActivationLink`;
    const token = this.GetToken();
    return this.http.post<any>(DataUrl, formData, token);
  }
  PostEnableDirectScheme(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/EnableDirectScheme/EnableDirectSchemes`;
    const token = this.GetToken();
    return this.http.post<any>(DataUrl, formData, token);
  }
  GetDirectSchemesStatus(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/EnableDirectScheme/Getschemestatus`;
    const token = this.GetToken();
    return this.http.post<any>(DataUrl, formData, token);
  }
  CheckAUKYC(PANNO, MobileNo) {
    const header = this.GetToken();
    //let DataUrl = `${this.ServerUrlThirdParty}/api/KycCheck/KycCheck?PANNo=${PANNO}&MobileNo=${MobileNo}`;
    let DataUrl = `${this.ServerUrlThirdParty}/api/KYCCheck/AUCVLKRAKYC?PANNo=${PANNO}&MobileNo=${MobileNo}`;
    console.log(DataUrl);
    const json = this.ConvertToJSON.QueryStringToJSON(DataUrl.split('?')[1]);

    return this.http.post<any>(DataUrl.split('?')[0], json, header);
  }

  //fetch NPSClientDetails data using clientBasicInfoId
  GetNPSClientDetails(ClientBasicInfoId: number) {
    let s_url = `${this.ServerUrl2}/api/Customer360Service/NPSClientDetails?ClientBasicInfoId=${ClientBasicInfoId}`;
    //return this.http.get<any>(url);
    const tokenOption = this.GetToken();
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  GetNPSDropDownData(code: any, filtername: any): Observable<any> {
    let s_url = '';
    if (filtername == 'state') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=StateList&REFF_ID=${code}`;
    } else if (filtername == 'gender') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=GenderList&REFF_ID=${code}`;
    } else if (filtername == 'title') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=Title&REFF_ID=${code}`;
    } else if (filtername == 'marital') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=MaritalStatusList&REFF_ID=${code}`;
    } else if (filtername == 'accounttype') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=Account_TypeList&REFF_ID=${code}`;
    } else if (filtername == 'occupationtype') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=OccupationList&REFF_ID=${code}`;
    } else if (filtername == 'PoliticallyExposedFlag') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=PoliticallyExposedFlag&REFF_ID=${code}`;
    } else if (filtername == 'IncomeRangeList') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=IncomeRangeList&REFF_ID=${code}`;
    } else if (filtername == 'Relationship') {
      s_url = `${this.ServerUrl2}/api/DropDown/NPSDetails?TRANS_TYPE=Relationship&REFF_ID=${code}`;
    }
    //return this.http.get<any>(url);
    const tokenOption = this.GetToken();
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetTitleList(): Observable<any> {
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=ClientTitle`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    console.log('GetStateList URL ' + DataUrl);
    console.log(
      'GetStateList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }
  SaveNPSProfile(body: any) {
    let url = `${this.ServerUrl2}/api/NPSClientOnbaoading/NPSClientOnbaoading`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  PostNPSDocument(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        //'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/NPSClientOnbaoading/UploadDocument`;
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }
  getKYCVerificationDetails(PANNO) {
    const header = this.GetToken();
    let DataUrl = `${this.ServerUrlThirdParty}/api/KYCCheck/getKYCVerificationDetails?PANNo=${PANNO}`;
    console.log(DataUrl);
    const json = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(
      DataUrl.split('?')[1]
    );
    return this.http.post<any>(DataUrl.split('?')[0], json, header);
  }
  PostMailConfigInfo(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl}/api/EmailConfigrationController/EmailConfigCont`;
    return this.http.post<any>(DataUrl, formData, headers);
  }
  GetRelationwithholderlist() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=MoborEmailRelation`;
    console.log('RelationWith Holder URL ' + DataUrl);
    console.log(
      'RelationWith Holder URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  GetCountryList(): Observable<any> {
    let DataUrl = `${this.ServerUrl2}/api/DropDown/OnboardingDetails?Flag=TransactionCountry`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');

    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };

    return this.http.get<any>(DataUrl, tokenOption).pipe();
  }

  UpdateNomineeDeclaration(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl2}api/ClientOnBoardingBSE/UpdateNomineeDeclaration`;
    //console.log(DataUrl)
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }
  GetNomineeStatus(formData): Observable<any> {
    let DataUrl = `${this.ServerUrl2}api/ClientOnBoardingBSE/GetNomineeStatus`;
    //console.log(DataUrl)
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }
  PostMailToMFLetstalkform(formData): Observable<any> {
    debugger;
    let DataUrl = `${this.ServerUrl5}/api/SendDetailsToMail/LetsTalkFrom_IFA`;
    return this.http.post<any>(DataUrl, formData, headers);
  }
  SubbrokerAmcList(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        //'Content-Type': 'application/json',
        Authorization: `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl2}/api/SubbrokerAmcList/GetSubbrokerAmcList`;
    return this.http.post<any>(DataUrl, formData, tokenOption);
  }

  GetTaxStatus() {
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=TAX_STATUS`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body =
      this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body).pipe();
  }
  GetEMandateStatus(ClientBasicInfoId) {
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=EMandateBankAllowStatus_JM&REFF_ID=${ClientBasicInfoId}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body =
      this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }
  IdentificationList() {
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=IDTYPE_LIST_NSE`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body =
      this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body).pipe();
  }
  GetAddressTypeList() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=ADDRESSTYPE_LIST_NSE`;
    console.log('GetAddressTypeList URL ' + DataUrl);
    console.log(
      'GetAddressTypeList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    //return this.http.get<any>(DataUrl,tokenOption).pipe();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body =
      this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetSourceOfWealth() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(
      sessionStorage.getItem('m5JkoXISmYRAIuY')
    );
    let User_Type = this.EncrdecrService.getDecr(
      sessionStorage.getItem('L2D3506kIHSk3E0')
    );
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(
      token + '@' + UserId + '|' + User_Type + '|' + IpAddress
    );
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`
      })
    };
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=INCOME_SOURCE`;
    console.log('GetAddressTypeList URL ' + DataUrl);
    console.log(
      'GetAddressTypeList URL token ' +
        token +
        '@' +
        UserId +
        '|' +
        User_Type +
        '|' +
        IpAddress
    );
    //return this.http.get<any>(DataUrl,tokenOption).pipe();
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body =
      this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  GetRelationwithholderlist_self(
    flag: string,
    InputPara: string,
    cbid: string
  ) {
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=${flag}&REFF_ID=${InputPara}&REFF_ID2=${cbid}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body =
      this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }
  GetFamilyMemberList(clientid: any) {
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=GetFamilyMemberList&REFF_ID=${clientid}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body =
      this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body).pipe();
  }
  SendJMOTP(formData, baseURL): Observable<any> {
    let DataUrl = this.serverConfig.ServerUrl + baseURL;
    //console.log(DataUrl)

    const req = {
      data: this.EncrdecrService.setEncr(formData)
    };
    return this.http.post<any>(DataUrl, req, headers);
  }
  NomineeDetailsStagging(Request: any) {
    let DataUrl = `${this.ServerUrl2}/api/NomineeDetailsStagging/Details`;
    return this.http.post<any>(DataUrl, Request, this.GetToken()).pipe();
  }
  GetClientInfoNominee(
    ClientBasicInfoId,
    HoldingType = 'SI',
    SecondHolderID = 0,
    ThirdHolderID = 0
  ): Observable<any> {
    debugger;
    let DataUrl = `${this.ServerUrl2}/api/ClientOnBoardingBSE/ClientProfileDetails`;
    const QueryString = `ClientBasicInfoId=${this.EncrdecrService.setEncr(ClientBasicInfoId)}&SecondHolderId=${this.EncrdecrService.setEncr(SecondHolderID.toString())}&ThirdHolderId=${this.EncrdecrService.setEncr(ThirdHolderID.toString())}&HoldingType=${this.EncrdecrService.setEncr(HoldingType)}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);

    return this.http.post<any>(DataUrl, body, this.GetToken()).pipe();
  }
  NomineeDetailsStaggingDeepLink(Request: any) {
    let DataUrl = `${this.ServerUrl}/api/NomineeDetailsStagging/Deeplink`;
    return this.http.post<any>(DataUrl, Request, this.GetToken()).pipe();
  }
}
